import {Box, HStack, Show, Spinner, VStack} from 'platform/foundation';

import {useEffect, useRef} from 'react';

import {chatPublicApi} from '../../../api/chatPublicApi';
import {AgentMessage} from './AgentMessage';
import {CustomerMessage} from './CustomerMessage';

interface TimelineProps {
  conversationId: string;
}

export function Timeline(props: TimelineProps) {
  const [markAsRead] = chatPublicApi.useMarkPublicEventsAsReadMutation();

  const conversationQuery = chatPublicApi.useGetPublicConversationQuery({
    conversationId: props.conversationId,
  });

  const users = conversationQuery.data?.users;

  const eventsQuery = chatPublicApi.useGetPublicEventsQuery({conversationId: props.conversationId});
  const events = eventsQuery.data;

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [events]);

  useEffect(() => {
    const lastEvent = events?.[events.length - 1];

    const isReadByCustomer = !!lastEvent?.readBy.find((readBy) => readBy.user.type === 'PUBLIC');

    if (!isReadByCustomer) {
      markAsRead({conversationId: props.conversationId});
    }
  }, [events, props.conversationId, markAsRead]);

  const publicEvents = events?.filter((e) => e.sender.type === 'PUBLIC');
  const lastPublicEvent = publicEvents?.[publicEvents.length - 1];

  return (
    <Box flex={1} overflow="auto" ref={scrollContainerRef}>
      <VStack spacing={2} maxHeight={100}>
        <Show when={conversationQuery.isLoading || eventsQuery.isLoading}>
          <HStack align="center" justify="center" height="100%">
            <Spinner size="default" />
          </HStack>
        </Show>
        {events?.map((event) => {
          const isLastPublicEvent = event.id === lastPublicEvent?.id;
          const isRead = event.readBy.some((readBy) => readBy.user.type === 'DMS');

          return event.sender.type === 'DMS' ? (
            <AgentMessage key={event.id} message={event.content} createdAt={event.createdAt} />
          ) : (
            <CustomerMessage
              key={event.id}
              message={event.content}
              createdAt={event.createdAt}
              isRead={isLastPublicEvent && isRead}
            />
          );
        })}
      </VStack>
    </Box>
  );
}
